import * as React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';


export default class LiquidacionesListItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            liquidaciones: props.liquidaciones
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.liquidaciones !== this.props.liquidaciones) {
          this.setState({ liquidaciones: this.props.liquidaciones })
        }
    };

    render = () => {
        return (
            <div className="row justify-content-between align-items-center p-10">
                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="col-1"><small>N°</small></th>
                                    <th className="col-2"><small>Seller</small></th>
                                    <th className="col-2"><small>Fecha</small></th>
                                    <th className="col-1"><small>Ordenes</small></th>
                                    <th className="col-1"><small>Imp. Ordenes</small></th>
                                    <th className="col-1"><small>Comisiones</small></th>
                                    <th className="col-1"><small>Novedades</small></th>
                                    <th className="col-1"><small>Neto Liquidación</small></th>
                                    <th className="col-1"><small>Estado</small></th>
                                    <th className="col-2"><small>Editar</small></th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.liquidaciones.map((liquidacion, i) => {
                                    return (
                                        <tr key={i} className="hover-background-color">

                                            <td><small>{liquidacion.idLiquidacion}</small></td>
                                            <td><small>{liquidacion.razonSocialSeller}</small></td>
                                            <td><small>{liquidacion.mostrarFecha}</small></td>
                                            <td><small>{liquidacion.cantidadOrdenes}</small></td>
                                            <td><small>${liquidacion.totalOrden}</small></td>
                                            <td><small>${liquidacion.comisionTotal}</small></td>
                                            <td><small>${liquidacion.totalNovedades}</small></td>
                                            <td><small>${liquidacion.totalLiquidacion}</small></td>
                                            <td>
                                                <small>
                                                {
                                                    liquidacion.idTipoEstadoLiquidacion !== 2 ?
                                                    'Liquidada' : "En Preparación"
                                                }
                                                </small>
                                            </td>
                                            {
                                                liquidacion.idTipoEstadoLiquidacion !== 2 ?
                                                
                                                <td>
                                                    <button 
                                                        type="button" 
                                                        className="btn" 
                                                        title="Consultar" 
                                                        onClick={() => this.props.onLiquidacionFunction(liquidacion.idSeller, liquidacion.idLiquidacion)} 
                                                    >
                                                        <i className="fa fa-clipboard" aria-hidden="true"/>
                                                    </button>
                                                </td>

                                                :

                                                <td>
                                                    <button 
                                                        type="button" 
                                                        className="btn"
                                                        title="Editar" 
                                                        onClick={() => this.props.onLiquidacionEditableFunction(liquidacion.idSeller, liquidacion.idLiquidacion)} 
                                                    >
                                                        <i className="fa fa-clipboard" aria-hidden="true"/>
                                                    </button>

                                                    <OverlayTrigger
                                                        key={`overlay-delete-${i}`}
                                                        trigger="click"
                                                        rootClose={true}
                                                        placement={"top"}
                                                        overlay={
                                                            <Popover id={`popover-delete-${i}`}>
                                                                <Popover.Header as="h3">
                                                                    ¿Eliminar Liquidación?
                                                                </Popover.Header>
                                                                <Popover.Body className="row justify-content-center">
                                                                    <button 
                                                                        className="btn btn-sm background-rojo-megatone col-auto"
                                                                        onClick={() => this.props.eliminarLiquidacionFunction(liquidacion.idLiquidacion)}
                                                                    >
                                                                        Eliminar
                                                                    </button>
                                                                </Popover.Body>
                                                            </Popover>
                                                        }
                                                    >
                                                        <button 
                                                        title="Eliminar" 
                                                        type="button" 
                                                        className="btn color-rojo-megatone"
                                                        >
                                                            <i className="fa fa-trash" aria-hidden="true"/>
                                                        </button>
                                                    </OverlayTrigger>
                                                </td>
                                            }
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}